'use strict';

function _typeof(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports['default'] = void 0;

var _react = _interopRequireWildcard(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _styles = _interopRequireDefault(require('./styles'));

var _helpers = require('./helpers');

var _Tooltip = _interopRequireDefault(require('../Tooltip'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== 'function') return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (
    obj === null ||
    (_typeof(obj) !== 'object' && typeof obj !== 'function')
  ) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj['default'] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr)))
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (
      var _i = arr[Symbol.iterator](), _s;
      !(_n = (_s = _i.next()).done);
      _n = true
    ) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MaskInputContainer = _styles['default'].MaskInputContainer,
  MaskInputStyle = _styles['default'].MaskInputStyle;

var MaskInput = function MaskInput(props) {
  var label = props.label,
    height = props.height,
    width = props.width,
    placeholder = props.placeholder,
    optional = props.optional,
    optionalTag = props.optionalTag,
    requiredTag = props.requiredTag,
    disabled = props.disabled,
    helperText = props.helperText,
    charLimit = props.charLimit,
    onChange = props.onChange,
    iconLeft = props.iconLeft,
    onIconLeftClick = props.onIconLeftClick,
    iconRight = props.iconRight,
    onIconRightClick = props.onIconRightClick,
    imageRight = props.imageRight,
    rounded = props.rounded,
    className = props.className,
    value = props.value,
    toolTip = props.toolTip,
    mask = props.mask,
    maskingType = props.maskingType,
    validate = props.validate,
    validateOnChange = props.validateOnChange;

  var _useState = (0, _react.useState)(props.type || 'text'),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    formattedValue = _useState8[0],
    setFormattedValue = _useState8[1];

  var state = {
    setError: setError,
    setErrorMessage: setErrorMessage,
    setFormattedValue: setFormattedValue,
    formattedValue: formattedValue,
    onChange: onChange,
  };
  (0, _react.useEffect)(
    function() {
      setType(props.type);
    },
    [props.type]
  ); // choose Default (you provide the mask), Phone (###)###-####, Card ####-####-####-####

  return /*#__PURE__*/ _react['default'].createElement(
    MaskInputContainer,
    {
      className: 'maskInput-container '.concat(className),
      'data-automation': 'maskIinput-container-'.concat(label),
      error: error,
      width: width,
      height: height,
      helperText: helperText,
      type: props.type,
      toolTip: toolTip,
    },
    /*#__PURE__*/ _react['default'].createElement(
      'div',
      {
        className: 'label-container '.concat(toolTip ? 'tooltip' : ''),
      },
      label ? label : '',
      optionalTag
        ? /*#__PURE__*/ _react['default'].createElement(
            'span',
            null,
            '- Optional'
          )
        : '',
      requiredTag
        ? /*#__PURE__*/ _react['default'].createElement(
            'span',
            null,
            '- Required'
          )
        : '',
      toolTip
        ? /*#__PURE__*/ _react['default'].createElement(_Tooltip['default'], {
            content: toolTip,
          })
        : ''
    ),
    helperText &&
      /*#__PURE__*/ _react['default'].createElement(
        'p',
        {
          className: 'helper-text',
        },
        helperText
      ),
    maskingType === 'phone'
      ? /*#__PURE__*/ _react['default'].createElement(
          'div',
          {
            className: 'phoneSection',
          },
          maskingType === 'phone' &&
            /*#__PURE__*/ _react['default'].createElement(
              'div',
              {
                className: 'areaWrapper',
              },
              /*#__PURE__*/ _react['default'].createElement(
                'div',
                {
                  className: 'plusCode',
                },
                '+'
              ),
              /*#__PURE__*/ _react['default'].createElement(
                'div',
                {
                  className: 'areaCode',
                },
                '1'
              )
            ),
          /*#__PURE__*/ _react['default'].createElement(MaskInputStyle, {
            className: 'maskInput-field',
            'data-automation': 'maskInput-field-'.concat(label),
            height: height,
            mask: mask,
            maskType: maskingType,
            width: width,
            placeholder: placeholder,
            disabled: disabled,
            onChange: function onChange(e) {
              return (0, _helpers.handleChange)(
                e,
                _objectSpread(_objectSpread({}, props), state)
              );
            },
            onBlur: function onBlur(e) {
              return (0, _helpers.handleBlur)(
                e,
                _objectSpread(_objectSpread({}, props), state)
              );
            },
            iconLeft: iconLeft,
            iconRight: iconRight,
            imageRight: imageRight,
            rounded: rounded,
            value: formattedValue,
          })
        )
      : /*#__PURE__*/ _react['default'].createElement(MaskInputStyle, {
          className: 'maskInput-field',
          'data-automation': 'maskInput-field-'.concat(label),
          height: height,
          mask: mask,
          maskType: maskingType,
          width: width,
          placeholder: placeholder,
          disabled: disabled,
          onChange: function onChange(e) {
            return (0, _helpers.handleChange)(
              e,
              _objectSpread(_objectSpread({}, props), state)
            );
          },
          onBlur: function onBlur(e) {
            return (0, _helpers.handleBlur)(
              e,
              _objectSpread(_objectSpread({}, props), state)
            );
          },
          iconLeft: iconLeft,
          iconRight: iconRight,
          imageRight: imageRight,
          rounded: rounded,
          value: formattedValue,
        }),
    iconLeft &&
      /*#__PURE__*/ _react['default'].createElement('i', {
        className: 'icon-left '.concat(iconLeft),
        onClick: onIconLeftClick,
      }),
    iconRight &&
      /*#__PURE__*/ _react['default'].createElement('i', {
        className: 'icon-right '.concat(iconRight),
        onClick: onIconRightClick,
      }),
    imageRight &&
      /*#__PURE__*/ _react['default'].createElement('img', {
        className: 'image-right '.concat(imageRight),
        src: imageRight,
      }),
    /*#__PURE__*/ _react['default'].createElement(
      'div',
      {
        className: 'details-container',
      },
      error &&
        /*#__PURE__*/ _react['default'].createElement(
          'p',
          {
            className: 'error-field',
            'data-automation': 'input-error-'.concat(label),
          },
          /*#__PURE__*/ _react['default'].createElement('i', {
            className: 'far fa-exclamation-circle',
          }),
          errorMessage
        )
    )
  );
};

MaskInput.propTypes = {
  type: _propTypes['default'].string,
  label: _propTypes['default'].string,
  height: _propTypes['default'].string,
  width: _propTypes['default'].string,
  placeholder: _propTypes['default'].string,
  optional: _propTypes['default'].bool,
  optionalTag: _propTypes['default'].bool,
  requiredTag: _propTypes['default'].bool,
  disabled: _propTypes['default'].bool,
  helperText: _propTypes['default'].string,
  onChange: _propTypes['default'].func.isRequired,
  iconLeft: _propTypes['default'].string,
  onIconLeftClick: _propTypes['default'].func,
  iconRight: _propTypes['default'].string,
  onIconRightClick: _propTypes['default'].func,
  imageRight: _propTypes['default'].string,
  rounded: _propTypes['default'].bool,
  onError: _propTypes['default'].func,
  className: _propTypes['default'].string,
  value: _propTypes['default'].string.isRequired,
  mask: _propTypes['default'].string,
  maskingType: _propTypes['default'].string,
  validate: _propTypes['default'].func,
  validateOnChange: _propTypes['default'].bool,
};
var _default = MaskInput;
exports['default'] = _default;
